import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/browse-services/page.tsx");
